<template>
    <div class="o-protectors">
        <m-tabs
            v-if="!isSubstitutes"
            :items="protectorsTypes"
            @input="build('type', $event.value)"
            :selected="query.type"
        />
        <o-list
            vuex-action-fetch="fetchProtectors"
            :vuex-fetch-options="isSubstitutes ? fetchOptions : null"
            vuex-action-fetch-next-page="fetchProtectorsNextPage"
            vuex-action-remove-query-element-and-fetch="removeProtectorsQueryElementAndFetch"
            vuex-action-reset-query-and-fetch="resetProtectorsQueryAndFetch"
            vuex-getter-filters="protectorsQueryFilters"
            vuex-getter-model="protectors"
            vuex-getter-status="protectorsStatus"
            router-single-name="protector"
        >
            <template slot="list" slot-scope="props">
                <div class="m-list__itemPhoto">
                    <a-image
                        v-if="
                            props.list.item.photos &&
                                props.list.item.photos.length > 0 &&
                                !!props.list.item.photos.find(
                                    item => item.is_main === true
                                )
                        "
                        :src="
                            props.list.item.photos.find(
                                item => item.is_main === true
                            ).full_uri
                        "
                        :alt="props.list.item.name"
                    />
                    <a-icon v-else icon="Protectors" />
                </div>
                <p
                    class="m-list__itemTitle m-list__itemTitle--margins m-list__itemTitle--capitalize o-protectors__item"
                    :class="{
                        'o-protectors__item--selected':
                            props.list.item.agrii_protectors &&
                            props.list.item.agrii_protectors.length > 0
                    }"
                    :style="
                        authIsAdvisor && props.list.item.position_group
                            ? { color: props.list.item.position_group.hex }
                            : false
                    "
                >
                    {{ props.list.item.name }}
                    <span
                        v-if="props.list.item.is_deleted"
                        class="m-list__itemTitleRed"
                    >
                        <br />archiwalny
                    </span>
                </p>
                <div class="m-list__itemIcons">
                    <a-icon
                        v-if="props.list.item.youtube_link"
                        class="m-list__icon"
                        icon="Video"
                    />
                    <a-icon
                        class="m-list__icon"
                        :icon="
                            props.list.item.notes &&
                            props.list.item.notes.length > 0
                                ? 'Note'
                                : 'NoteLight'
                        "
                    />
                    <a-icon
                        class="m-list__icon"
                        :icon="
                            props.list.item.is_favorite
                                ? 'Favorite'
                                : 'FavoriteLight'
                        "
                    />
                </div>
            </template>
        </o-list>
    </div>
</template>

<script>
export default {
    metaInfo: {
        title: 'Środki'
    },
    data() {
        return {
            fetchOptions: {
                isSubstitutes: true,
                id: this.$route.params.id
            }
        }
    },
    computed: {
        protectorsTypes() {
            return this.$store.getters.protectorsTypes
        },
        query() {
            return this.$store.getters.protectorsQuery
        },
        authIsAdvisor() {
            return this.$store.getters.authIsAdvisor
        },
        isSubstitutes() {
            return this.$route.meta.isSubstitutes
        }
    },
    methods: {
        build(name, value) {
            this.$store
                .dispatch('setProtectorsSearchQuery', {
                    name,
                    value
                })
                .then(() => {
                    this.$store
                        .dispatch(
                            'fetchProtectors',
                            this.isSubstitutes ? this.fetchOptions : false
                        )
                        .catch(() => {})
                })
        }
    },
    created() {
        if (this.isSubstitutes) {
            this.$store
                .dispatch('fetchProtectors', this.fetchOptions)
                .catch(() => {})
        } else {
            this.$store.dispatch('resetProtectorsFavorite')
        }
    }
}
</script>
